import elSelectLoadMore from './elSelectLoadMore.js';
import auth from './auth.js';
import highlightBox from './highlightBox.js';
const directives = {
  auth,
  elSelectLoadMore,
  highlightBox,
};

export function setDirective(app) {
  Object.keys(directives).forEach((key) => {
    app.directive(key, directives[key]);
  });
}
